import type { AuthBackend, Session, SignOutArgs } from "../types";
import { getAuthHeaders, getSession } from "./getSession";
import { signIn, signInWithRedirect } from "./signIn";
import { signOut } from "./signOut";

export class TrimbleAuthBackend implements AuthBackend {
  readonly id = "trimble" as const;
  readonly navigatesOnSignOut = true;

  signIn(args: { email: string; password: string }): Promise<void> {
    return signIn(args);
  }

  signInWithRedirect(args?: { returnTo?: string }): Promise<void> {
    return signInWithRedirect(args);
  }

  signOut(args?: SignOutArgs): Promise<void> {
    return signOut(args);
  }

  getSession(): Promise<Session | null> {
    return getSession();
  }

  getAuthHeaders(): Promise<Record<string, string>> {
    return getAuthHeaders();
  }

  shouldUseCredentialsInclude(): boolean {
    return false;
  }
}

export const trimbleAuthBackend = new TrimbleAuthBackend();
